import { render, staticRenderFns } from "./ToolPage.vue?vue&type=template&id=536ee1a9&scoped=true&"
import script from "./ToolPage.vue?vue&type=script&lang=ts&"
export * from "./ToolPage.vue?vue&type=script&lang=ts&"
import style0 from "./ToolPage.vue?vue&type=style&index=0&id=536ee1a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ee1a9",
  null
  
)

export default component.exports